export default function Features() {
    return(
        <div className="features">
            <div className='card'>
                <span className="material-icons font__30 text__primary">
                    check_circle
                </span>
                <div className='font2 text-[20px]'>Enter job title and job description</div>
                <div className=''>
                    Simply copy and paste the job details and let ai pick the most relevant skills related to it.
                </div>
            </div>
            <div className='card'>
                <span className="material-icons font__30 text__primary">
                    check_circle
                </span>
                <div className='font2 text-[20px]'>Select what skills you want to test</div>
                <div className=''>
                    Pick only the skills you want your candidate to have and the AI has suggested.
                </div>
            </div>
            <div className='card'>
                <span className="material-icons font__30 text__primary">
                    check_circle
                </span>
                <div className='font2 text-[20px]'>Select the questions you want for the interview</div>
                <div className=''>
                    After picking the skills, the AI will generate related questions to test those skills. Pick those too and you are all set
                </div>
            </div>
            <div className='card'>
                <span className="material-icons font__30 text__primary">
                    check_circle
                </span>
                <div className='font2 text-[20px]'>Save the interview</div>
                <div className=''>
                    After following all the previous steps, you can see a summary of your interview and just save it. Share it or answer right away.
                </div>
            </div>
            <div className='card'>
                <span className="material-icons font__30 text__primary">
                    check_circle
                </span>
                <div className='font2 text-[20px]'>Answer the interview</div>
                <div className=''>
                    Answer the interview yourself and proof the AI generated results.
                </div>
            </div>
            <div className='card'>
                <span className="material-icons font__30 text__primary">
                    check_circle
                </span>
                <div className='font2 text-[20px]'>Get the results</div>
                <div className=''>
                    Detailed results for each question and aggregated statistics
                </div>
            </div>
        </div>
    )
}

